import { Paragraph } from 'docx';

// Utils
import { isEmptyValueArray } from '@shared/utils';
import { filterValidSkills } from '@/utils/resume';
import { bodyRun, dividerParagraph, sidebarSectionTitle } from '../../utils';

// Types
import { TemplateProps } from '@/components/template/resume/type';

// Constants
import { FONT_SIZES, SPACINGS } from '../../constants';

// Tokens
import { SECTION_TITLES } from '@/components/template/resume/Default/tokens';

/** Creates the sidebar technical skills section */
export const TechnicalSkillsSection = (
  skills: TemplateProps['data']['technicalSkills'],
): Paragraph[] => {
  const filtered = filterValidSkills(skills ?? []);
  if (isEmptyValueArray(filtered)) return [];

  const paragraphs: Paragraph[] = [
    dividerParagraph({ before: 0, after: SPACINGS.sectionDividerGap }),
    sidebarSectionTitle(SECTION_TITLES.skills, 0),
  ];

  for (const { name: categoryName = '', items = [] } of filtered) {
    if (categoryName) {
      paragraphs.push(
        new Paragraph({
          spacing: { before: SPACINGS.medium },
          children: [bodyRun(categoryName, { bold: true })],
        }),
      );
    }

    for (const skill of items) {
      if (!skill?.trim()) continue;

      paragraphs.push(
        new Paragraph({
          spacing: { before: SPACINGS.bulletBefore, line: SPACINGS.skillLine },
          indent: { left: SPACINGS.bulletIndent },
          children: [bodyRun(`• ${skill}`, { size: FONT_SIZES.sm })],
        }),
      );
    }
  }

  return paragraphs;
};
